import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  video: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    transition: 'opacity 1s ease-out'
  },
  videoRatio: {
    '&:before': {
      paddingTop: '56.25%',
      content: '""',
      display: 'block'
    },
    flex: 1,
    position: 'relative',
    overflow: 'hidden'
  },
  videoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  videoPlayer: {
    height: '100%',
    width: '100%'
  },
  hidden: {
    opacity: 0
  }
})

export default useStyles
